//抛出混入对象，方便外部访问
export const mixin = {
    data() {
        return {
            menuCodeMix: "",
            isRule: false,
            isTableLoading: false,
            searchYear: "",
            searchTerm: "",
            tableData: [],
            selectRow: null,
            defaultProps: {
                children: "child",
                label: "integralName",
                value: "integralCode",
            },
            imgPathList: [],
            //图片的预览
            imgVisible: false,
            imgUrl: "",
            delVisible: false,
            addVisible: false,
            pageObj: {
                current: 1,
                total: 0,
                size: 10,
                sizeList: [10, 15, 20, 25, 30],
            },
            form: {
                schoolYear: "",
                schoolTerm: "",
                ruleList: "",
                score: "",
                teacherId: "",
                teacherName: "",
            },
            rules: {
                schoolYear: [
                    {
                        required: true,
                        message: "请选择学年",
                        trigger: ["change", "blur"],
                    },
                ],
                schoolTerm: [
                    {
                        required: true,
                        message: "请选择学期",
                        trigger: ["change", "blur"],
                    },
                ],
                teacherId: [
                    {
                        required: true,
                        message: "请选择教师",
                        trigger: ["change", "blur"],
                    },
                ],
                teacherName: [
                    {
                        required: true,
                        message: "教师名称不符合规范",
                        trigger: ["change", "blur"],
                    },
                ],
                ruleList: [
                    {
                        required: true,
                        message: "请选择等级分类",
                        trigger: ["change", "blur"],
                    },
                ],
            },
            //审核框
            checkVisible: false,
        }
    },
    computed: {

    },
    created() {
        // this.searchYear = this.curYearPro;
        // this.searchTerm = this.curTermPro;
        this.getMenuCodeMix(this.userInfo.menuInfoList);
        this.$store.dispatch("getRuleOptions", this.menuCodeMix); //积分规则下拉列表,获奖分类
        this.selectLsit(1); //首页list

        this.isAdmin ? "" : this.teacherKeyChange(this.userInfo.userName);//教师下拉列表 教师角色自动赋值
    },
    methods: {
        getMenuCodeMix(arr) {
            arr.forEach((item) => {
                if (item.menuInfoList && item.menuInfoList.length > 0) {
                    this.getMenuCodeMix(item.menuInfoList);
                    return;
                }
                if (
                    this.$route.path.indexOf(item.menuCode) != -1
                ) {
                    this.menuCodeMix = item.menuCode
                }
            });
        },
        //操作按钮是否失效
        isDisabled(scope) {
            return this.isAdmin ? false : this.userInfo.userId != scope.row.teacherId;
        },
        //状态审核 小手控制
        isPointer(status) {
            if (this.isAdmin) {
                if (status === "0" || status === "2") {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (status === "2") {
                    console.log("true");
                    return true;
                } else {
                    console.log("false");
                    return false;
                }
            }
        },
        //教师选择的列表
        teacherKeyChange(keyword) {
            this.$store.dispatch("getTeacherOptions", keyword);
        },
        // 获得积分
        getIntegralNum() {
            //递归
            this.recursion(this.ruleOptions || []);
        },
        recursion(arr) {
            arr.forEach((item) => {
                if (item.child && item.child.length > 0) {
                    this.recursion(item.child);
                    return;
                }
                if (
                    item.integralCode ===
                    this.form.ruleList[this.form.ruleList.length - 1]
                ) {
                    this.form.score = item.integralNum;
                }
            });
        },
        //ruleOptionsList数组 是否 包含 ruleList数组
        isInclude(ruleOptionsList, ruleList) {
            return ruleList.every((item) => {
                return ruleOptionsList.some((sub) => {
                    return sub === item;
                });
            });
        },
        // 删除 弹框
        showDelPop(index, row) {
            this.selectRow = row;
            this.delVisible = true;
        },
        //分页
        handleSizeChange(pageSize) {
            this.pageObj.size = pageSize;
            this.selectLsit(1, pageSize);
        },
        handleCurrentChange(curPage) {
            this.selectLsit(curPage);
        },
        //查看图片或者下载文件
        showImg(url, tit = null, imgList = []) {
            if (!url) {
                this.$message({
                    message: "您还未传文件哦！",
                    type: "success",
                });
                return
            }
            let FileEnd = url.replace(/.+\./, "");
            if (["png", "jpeg", "jpg"].indexOf(FileEnd.toLowerCase()) != -1) {
                this.imgVisible = true;
                this.imgShowClick(url, imgList.map(u => u.url))
                this.imgUrl = url;
            } else {
                this.download(url, tit || "文件")
            }
        },
        imgShowClick(imgSrc, imgList) {
            const imgListFlag = imgList instanceof Array && imgList.length;
            if (imgSrc) {
                if (imgListFlag) {
                    this.imgPathList = imgList;
                } else {
                    this.imgPathList = [];
                    this.imgPathList.push(imgSrc);
                }
                this.isShow = true;
            } else if (imgListFlag) {
                this.imgPathList = imgList;
                this.isShow = true;
            } else {
                this.$message.info("当前没有可预览的图片");
            }
        },
        //下载
        download(url, tit) {
            return fetch(url).then((res) =>
                res.blob().then((blob) => {
                    let a = document.createElement("a");
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = tit;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
            );
        },
    },
    watch: {
        "form.teacherId"(newValue) {
            if (newValue && this.teacherOptions) {
                let teacherObj = this.teacherOptions.find(
                    (item) => item.userId === newValue
                );
                this.form.teacherName = teacherObj && teacherObj.userName;
            }
        },
        //设置新增时默认 的学年 和 学期
        "form.schoolYear": {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.form.schoolYear = this.curYearPro;
                }
            },
        },
        "form.schoolTerm": {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.form.schoolTerm = this.curTermPro;
                }
            },
        },
        //教师角色 新增默认是本人
        "form.teacherId": {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.form.teacherId = this.isAdmin ? "" : this.userInfo.userId;
                }
            },
        },
    },

}
